/**
 * 年月日の情報を持つインターフェース
 */
type IDate = IYearMonth & IDay;

/**
 * IDate型かどうかを判定する
 * @param date - 日付情報
 */
export const isIDate = (date: any): date is IDate => {
  return date !== undefined && date.year !== undefined && date.month !== undefined && date.day !== undefined;
};
/**
 * 年月の情報を持つインターフェース
 * @property year - 年
 * @property month - 月
 */
interface IYearMonth {
  year: number;
  month: number;
}

/**
 * 日の情報を持つインターフェース
 * @property day - 日
 */
interface IDay {
  day: number;
}

/**
 * 営業日の情報を持つインターフェース
 * @property days - 営業日の配列
 */
interface IBizDays extends IYearMonth {
  days: number[];
}

/**
 * カレンダーの情報を持つインターフェース
 * @property organizationId - 組織ID
 * @property updatedAt - 更新日時
 * @property workDays - 営業日の配列
 */
interface ICalendar {
  organizationId: string;
  updatedAt: number;
  workDays: IBizDays[];
}

/**
 * IYearMonth型をシリアライズする
 * @param iYearMonth - 年月情報
 * @returns 年_月の文字列
 */
export const serialize = (iYearMonth: IYearMonth) => iYearMonth.year + '_' + iYearMonth.month;

/**
 * 日付関連で使用する単位
 */
type DateUnitType = 'day' | 'week' | 'month' | 'unknown';

/**
 * 文字列型の値をDateUnitType型へ変換する
 * @param target - 変換対象の文字列
 */
export const convertDateUnitType = (target: string): DateUnitType => {
  if (target === '日' || target === 'day' || target === 'days') return 'day';
  if (target === '週' || target === '週間' || target === 'week' || target === 'weeks') return 'week';
  if (target === 'ヶ月' || target === 'month' || target === 'months') return 'month';
  return 'unknown';
};

export type { IDate, IYearMonth, IDay, IBizDays, ICalendar, DateUnitType };
